/* jshint esversion: 6 */
import React, { useCallback } from 'react';
import useEmblaCarousel from 'embla-carousel-react';

const EmblaCarousel = (props) => {
    let { options, children } = props,
        extraClasses = (props.extraClasses !== undefined) ? props.extraClasses : '';

    const [emblaRef, emblaApi] = useEmblaCarousel(options);

    const slideCount = children.length ? children.length : 0;
    const wrapperClass = slideCount <= 1 ? 'single' : '';

    const scrollPrev = useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();

        if (emblaApi) {
            emblaApi.scrollPrev();
        }

    }, [emblaApi]);

    const scrollNext = useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();

        if (emblaApi) {
            emblaApi.scrollNext();
        }

    }, [emblaApi]);

    return (
        <div className={`carousel-wrapper ${extraClasses} ${wrapperClass}`}>
            <div className="carousel" ref={emblaRef}>
                <div className="carousel-slide-wrapper">
                    {children}
                </div>
            </div>
            {slideCount > 1 ? (
                <div className="carousel-controls">
                    <div className="carousel-previous" role="button" aria-label="previous carousel item" onClick={scrollPrev}>
                        <i className="icon ion-chevron-left"></i>
                    </div>
                    <div className="carousel-next" role="button" aria-label="next carousel item" onClick={scrollNext}>
                        <i className="icon ion-chevron-right"></i>
                    </div>
                </div>
            ) : null}
        </div>
    );

};

export default EmblaCarousel;
